<template>
<!-- pr-0 -->
    <v-container fluid class="pl-0">
        <v-row>
            <v-col>
                <v-data-table
                    :headers="archivingHeaders"
                    :items="item.archiveRows"
                    :expanded.sync="expandedItems"
                    show-expand
                    @click:row="expandItemByClick($event)"
                    :header-props="{ sortIcon: '' }"
                    :items-per-page="itemsPerPage"
                    hide-default-footer
                    :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                    class="noMinWidth"
                >
                <!-- Archiving alvqas -->
                    <template v-for="(header, i) in archivingHeaders" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                    </template>

                <!-- Items -->
                    <!-- Expand Icon -->
                    <template v-slot:[`item.data-table-expand`]="{ isExpanded }">
                        <v-icon 
                            v-if="isExpanded"
                            small 
                            class="ma-0 pa-0"
                            color="buttonStandard"
                        >fa-arrow-alt-circle-down</v-icon>
                        <v-icon 
                            v-else
                            small 
                            class="ma-0 pa-0"
                            color="buttonStandard"
                        >fa-arrow-alt-circle-right</v-icon>
                    </template>
                    <template v-slot:[`item.archivePeriod`]="{ item }">
                        <div :alvqa="alvqa + '-archive-' + item.id + '-text-period'">
                            {{ 
                                item.archivePeriod === null ?
                                $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') :
                                $alvPlugin.displayPeriod(item.archivePeriod) 
                            }}
                        </div>
                    </template>
                    <template v-slot:[`item.forward`]="{ item }">
                        <v-chip
                            small
                            :color="item.forward ? 'standard' : 'standardBrownIcon'"
                            :alvqa="alvqa + '-archive-' + item.id + '-chip-carry-forward'"
                        >
                            {{ 
                                item.forward ? $t("lang_GENERIC_CAPTION_WITH_CARRY_FORWARD") : $t("lang_GENERIC_CAPTION_WITHOUT_CARRY_FORWARD")
                            }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.net`]="{ item }">
                        <div :alvqa="alvqa + '-archive-' + item.id + '-text-net'">
                            {{ 
                                item.net !== null ? 
                                    $n(item.net, 'number') :  
                                    ( item.archivePeriod === null ?
                                        $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') : $n(0, 'number')
                                    )
                            }}
                        </div>
                    </template>
                    <template v-slot:[`item.sum`]="{ item }">
                        <div :alvqa="alvqa + '-archive-' + item.id + '-text-sum'">
                            {{ 
                                item.sum !== null ? 
                                    $n(item.sum, 'number') : 
                                    ( item.archivePeriod === null ? 
                                        $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') : $n(0, 'number')
                                    )
                            }}
                        </div>
                    </template>
                    <template v-slot:[`item.creditNumber`]="{ item }">
                        <div :alvqa="alvqa + '-archive-' + item.id + '-text-credit-number'">
                            {{ 
                                item.creditNumber === null ? 
                                    $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') : item.creditNumber 
                            }}
                        </div>
                    </template>
                    <template v-slot:[`item.archivedOn`]="{ item }">
                        <div :alvqa="alvqa + '-archive-' + item.id + '-text-archiving-date'">
                            {{ item.archivedOn !== null ? $d(new Date(item.archivedOn), 'alvDateTime',  $i18n.locale) : '' }}
                        </div>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                        <BaseIcon 
                            @click.stop="deleteArchiveLine(item)"
                            icon="delete"
                            color="#d1d1d1"
                            tooltipText="lang_GENERIC_CAPTION_DELETE"
                            :alvqa="alvqa + '-archive-' + item.id + '-icon-delete'"
                        />
                    </template>
                    <template v-slot:[`item.path`]="{ item }">
                        <BaseIcon 
                            v-if="item.path !== null"
                            @click.stop="downloadFile(item.path)"
                            icon="cloud_download"
                            tooltipText="lang_GENERAL_CAPTION_ICON_DOWNLOAD"
                            :alvqa="alvqa + '-archive-' + item.id + '-icon-download'"
                        />
                    </template>
                    <!-- EXPANDED ITEM -->
                    <template v-slot:expanded-item="{ item }">
                        <td
                            colspan="1"
                            style="background-color: var(--v-expandPanelBackground-base);"
                        ></td>
                        <td 
                            class="pl-0"
                            :colspan="archivingHeaders.length - 1"
                            style="background-color: var(--v-expandPanelBackground-base);"
                        >
                            <v-container fluid class="pl-0 pr-0">
                                <v-row>
                                    <v-col class="pr-0">
                                        <v-data-table
                                            :headers="contractGroupsHeaders"
                                            hide-default-footer
                                            :items="item.contracts"
                                            :header-props="{ sortIcon: '' }"
                                            :items-per-page="itemsPerPage"
                                            class="noMinWidth"
                                        >
                                        <!-- Contract groups Headers -->
                                            <template v-for="(header, i) in contractGroupsHeaders" v-slot:[`header.${header.value}`]>
                                                <span :alvqa="header.alvqa + '-' + item.sheetNumber" :key="i">{{ header.text }}</span> 
                                            </template>

                                        <!-- Contract groups Items -->
                                            <template v-slot:[`item.contractGroup`]="{ item }">
                                                <div :alvqa="alvqa + '-contract-group-' + item.id + '-text-contract-group'">
                                                    {{ 
                                                        item.typeOfContract === 'regular' ? 
                                                            $t('lang_LABEL_STATEMENTS_REGULAR_CONTRACT') :
                                                                (item.typeOfContract === 'crossRecouped' ?
                                                                $t('lang_LABEL_STATEMENTS_CROSS_RECOUPED') : '')
                                                    }}
                                                </div>
                                            </template>
                                            <template v-slot:[`item.result`]="{ item }">
                                                <div :alvqa="alvqa + '-contract-group-' + item.id + '-text-result'">
                                                    {{ item.result !== null ? $n(item.result, 'number') :  $n(0, 'number') }}
                                                </div>
                                            </template>
                                            <template v-slot:[`item.carryForward`]="{ item }">
                                                <div :alvqa="alvqa + '-contract-group-' + item.id + '-text-carry-forward'">
                                                    {{ item.carryForward !== null ? $n(item.carryForward, 'number') :  $n(0, 'number') }}
                                                </div>
                                            </template>
                                            <template v-slot:[`item.returns`]="{ item }">
                                                <BaseTooltip>
                                                    <template v-slot:content>
                                                        <span 
                                                            :alvqa="alvqa + '-contract-group-' + item.id + '-text-reserve-from-previous'"
                                                        >
                                                            {{ item.reserveFromPrevious !== null ? $n(item.reserveFromPrevious, 'number') :  $n(0, 'number') }} / 
                                                        </span>
                                                    </template>
                                                    <template v-slot:text>{{ $t('lang_LABEL_STATEMENTS_PREVIOUS_RESERVE') }}</template>
                                                </BaseTooltip>
                                                <BaseTooltip>
                                                    <template v-slot:content>
                                                        <span 
                                                            :alvqa="alvqa + '-contract-group-' + item.id + '-text-reserve'"
                                                        >
                                                            {{ item.reserve !== null ? $n(item.reserve, 'number') :  $n(0, 'number') }} /
                                                        </span>
                                                    </template>
                                                    <template v-slot:text>{{ $t('lang_LABEL_STATEMENTS_CURRENT_RESERVE') }}</template>
                                                </BaseTooltip>
                                                <BaseTooltip>
                                                    <template v-slot:content>
                                                        <span 
                                                            :alvqa="alvqa + '-contract-group-' + item.id + '-text-reserve'"
                                                        >
                                                            {{ item.resolution !== null ? $n(item.resolution, 'number') :  $n(0, 'number') }}
                                                        </span>
                                                    </template>
                                                    <template v-slot:text>{{ $t('lang_LABEL_STATEMENTS_WITHHOLD_RESERVE') }}</template>
                                                </BaseTooltip>
                                            </template>
                                            <template v-slot:[`item.advance`]="{ item }">
                                                <div :alvqa="alvqa + '-contract-group-' + item.id + '-text-advance'">
                                                    {{ item.advance !== null ? $n(item.advance, 'number') :  $n(0, 'number') }}
                                                </div>
                                            </template>
                                            <template v-slot:[`item.costs`]="{ item }">
                                                <div :alvqa="alvqa + '-contract-group-' + item.id + '-text-costs'">
                                                    {{ item.costs !== null ? $n(item.costs, 'number') :  $n(0, 'number') }}
                                                </div>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'
import api from '@/api_alv'

export default {
    name: "LabelStatementsReadonly",
    props: {
        itemId: {
            type: Number
        }
    },
    components: {
        BaseIcon,
        BaseTooltip
    },
    data() {
        return {
            expandedItems: [],
            alvqa: 'label-statements-list-row-' + this.itemId + '-read-only'
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedLabelStatements.find(element => element.id === this.itemId)
            return item
        },

        archivingHeaders() {
            return [
                {
					text: '', 
					value: 'data-table-expand',
					align: 'center', 
                    sortable: false,
					width: "48px"
				},
                {
                    text: this.$t("lang_LABEL_STATEMENTS_CAPTION_ARCHIVE_PERIOD"), 
                    value: 'archivePeriod', 
                    align: 'left', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "140px",
                    alvqa: this.alvqa + '-archive-header-period'
                },
                {
                    text: '', 
                    value: 'forward',
                    align: 'left',
                    sortable: false,
                    width: "170px",
                    // class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_LABEL_STATEMENTS_CAPTION_NET') + ' ' + this.$store.getters.getSelectedCurrency, 
                    value: 'net',
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "150px",
                    alvqa: this.alvqa + '-archive-header-net'
                },
                {
                    text: this.$t('lang_LABEL_STATEMENTS_CAPTION_GROSS') + ' ' + this.$store.getters.getSelectedCurrency, 
                    value: 'sum',
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "150px",
                    alvqa: this.alvqa + '-archive-header-sum'
                },
                {
                    text: this.$t('lang_LABEL_STATEMENTS_CAPTION_CREDIT_NUMBER'), 
                    value: 'creditNumber',
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "190px",
                    alvqa: this.alvqa + '-archive-header-credit-number'
                },
                {
                    text: this.$t('lang_LABEL_STATEMENTS_CAPTION_ARCHIVED_ON'), 
                    value: 'archivedOn',
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "200px",
                    alvqa: this.alvqa + '-archive-header-archived-on'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    // class: 'text-no-wrap'
                },
				{
					text: '', 
					value: 'ghost',
					sortable: false,
                    // width: "1%",
                    class: 'text-no-wrap'
				},
                {
                    text: '', 
                    value: 'path',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    // class: 'text-no-wrap'
                }
            ]
        },

        contractGroupsHeaders() {
            return [
                {
                    text: this.$t("lang_LABEL_STATEMENTS_CAPTION_CONTRACT_GROUP"), 
                    value: 'contractGroup', 
                    align: 'left', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "290px",
                    alvqa: this.alvqa + '-contracts-header-contract-group'
                },
                {
                    text: this.$t("lang_LABEL_STATEMENTS_CAPTION_RESULT") + ' ' + this.$store.getters.getSelectedCurrency, 
                    value: 'result', 
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "150px",
                    alvqa: this.alvqa + '-contracts-header-result'
                },
                {
                    text: this.$t("lang_LABEL_STATEMENTS_CAPTION_CARRY_FORWARD") + ' ' + this.$store.getters.getSelectedCurrency, 
                    value: 'carryForward', 
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "150px",
                    alvqa: this.alvqa + '-contracts-header-carry-forward'
                },
                {
                    text: this.$t("lang_LABEL_STATEMENTS_CAPTION_RETURNS") + ' ' + this.$store.getters.getSelectedCurrency, 
                    value: 'returns', 
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "160px",
                    alvqa: this.alvqa + '-contracts-header-returns'
                },
                {
                    text: this.$t("lang_LABEL_STATEMENTS_CAPTION_ADVANCE") + ' ' + this.$store.getters.getSelectedCurrency, 
                    value: 'advance', 
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "200px",
                    alvqa: this.alvqa + '-contracts-header-advance'
                },
                {
                    text: this.$t("lang_LABEL_STATEMENTS_CAPTION_COSTS") + ' ' + this.$store.getters.getSelectedCurrency, 
                    value: 'costs', 
                    align: 'right', 
                    sortable: false,
                    // class: 'text-no-wrap',
                    width: "160px",
                    alvqa: this.alvqa + '-contracts-header-costs'
                },
                {
					text: '', 
					value: 'ghost',
					sortable: false,
                    // width: "1%",
                    class: 'text-no-wrap'
				}
            ]
        },

        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {
        // Expand behaviour when clicking on a row. 
        async expandItemByClick(item) {            
            if(this.expandedItems.includes(item)) { // close item.
                let indexOfItem = this.expandedItems.indexOf(item)
                this.expandedItems.splice(indexOfItem, 1) 
            } else { // open item             
                this.expandedItems.push(item) 
            }
        },
        deleteArchiveLine(item) {
            // to reload the readonly view after deleting the archive line, we need the alvid of the statement.
            let statementAlvId
            this.$store.getters.getExpandedLabelStatements.forEach(element => {
                if(element.id === this.itemId) statementAlvId = element.alvId
            });
            this.$store.commit('setSelectedLabelStatementsForDeleteArchive', statementAlvId)
            this.$store.commit('setSelectedLabelStatementsArchive', item)
            this.$store.commit('setDeletionDialogContext', 'SelectedLabelStatementsArchive')
            this.$store.commit('setShowDeletionDialog', true)
        },

        downloadFile(path) {
            api.getFileFromALV(path)
        }
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>